<!--
 * @Author: wsx
 * @Date: 2022-03-05 14:23:04
 * @LastEditTime: 2022-03-05 18:31:15
 * @Description:房屋
 * @FilePath: \smart-community\src\views\smartApplication\threeSolidQuery\components\house.vue
-->
<template>
  <div class="house">
    <div class="search-results-box">
      <ul class="search-results">
        <template v-for="(item, index) in houseList" :key="index">
          <li class="results-item">
            <div class="item-img">
              <img v-if="item.imageUrl" :src="url + item.imageUrl" alt="" />
              <img v-else src="~@/assets/images/moren.png" alt="" />
            </div>
            <div class="item-details">
              <div class="details-info">
                <el-link type="success" @click="personHandlear(item)">{{
                  item.houseAddress
                }}</el-link>
              </div>
              <div class="details-info">
                <span class="label">房屋类别</span>
                <span class="value">{{ item.houseType }}</span>
              </div>
              <div class="details-info">
                <span class="label">房屋性质</span>
                <span class="value">{{ item.houseProperty }}</span>
              </div>
              <div class="details-info">
                <span class="label">证件号码</span>
                <span class="value">{{ item.ownerCardNumber }}</span>
              </div>
              <div class="details-info">
                <span class="label">房屋状态</span>
                <span class="value">{{ item.status }}</span>
              </div>
              <div class="details-info">
                <span class="label">房主</span>
                <span class="value">
                  <el-link type="success" @click="personHandlear(item)">{{
                    item.ownerName
                  }}</el-link>
                </span>
              </div>
            </div>
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>
<script>
import { defineComponent, reactive, toRefs } from "vue";
import { houseList } from "@/api/threeSolid/fileManagement.js";
export default defineComponent({
  name: "house",
  components: {},
  emits: ["clickPerson", "clickHouse"],
  setup(props, context) {
    const data = reactive({
      houseList: [],
      url: window.imgURL,
    });
    const refData = toRefs(data);
    const personHandlear = (item) => {
      context.emit("clickPerson", item);
    };
    const houseHandlear = (item) => {
      context.emit("clickHouse", item);
    };
    // 请求数据
    const queryData = (params) => {
      console.log("house-请求数据-参数", params);
      return gethouseList(params);
    };
    // 获取房屋管理列表
    const gethouseList = async (search) => {
      const params = {
        page: 1,
        limit: 10000,
      };
      if (search) {
        params.search = search;
        console.log("params.search", params.search);
      }
      const res = await houseList(params);
      data.houseList = res.page.list;
      return res.page.list.length;
    };
    gethouseList();
    return {
      ...refData,
      personHandlear,
      houseHandlear,
      queryData,
      gethouseList,
    };
  },
});
</script>
<style lang="scss" scoped>
.house {
  .search-results-box {
    width: 100%;
    flex: 1;
    height: 100%;
    overflow: auto;
  }
  .search-results {
    width: 100%;
    .results-item {
      padding: 10px 0;
      width: 100%;
      border-bottom: 1px solid #aab2c5;
      @include flex-row-s-c;
      .item-img {
        width: 35%;
        height: 80%;
        img {
          width: 100%;
        }
      }
      .item-details {
        flex: 1;
        margin-left: 10px;
        line-height: 28px;
        width: 65%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-content: flex-start;
        .details-info {
          font-size: 14px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          // @include flex-row-sb-c;

          & > a {
            display: block;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          & > span {
            display: inline-block;
          }
          .label {
            width: 90px;
          }
          .value {
            flex: 1;
          }
        }
      }
    }
  }
}
</style>
